import axios from 'axios';

export class BuscaCepService {

  async execute (cep: string) {
    try {
      const sanitizedCep = cep.replace(/\D/g, '');
  
      if (sanitizedCep.length !== 8) {
        throw new Error('CEP inválido. Certifique-se de fornecer 8 dígitos.');
      }
  
      const response = await axios.get(`https://viacep.com.br/ws/${sanitizedCep}/json/`);
  
      if (response.data.erro) {
        throw new Error('CEP não encontrado.');
      }
  
      return response.data;
    } catch (error: any) {
      console.error('Erro ao buscar endereço:', error.message);
      return null;
    }
  };  

}
